import { ApiPage, emptyApiPage } from "../models/api-page.model";
import { Finance, FinanceBilledTo, FinanceRequest, FinanceRevenue, TopOffice } from "../models/finance.model";
import { apiService } from "./api.service";

export class FinanceService {
  private static BASE_PATH = "/api/v1/finance";

  static async getFinanceReport(startDate: Date, endDate?: Date, officeId?: string, mtd?: string): Promise<Finance | null> {
    let adjustedEndDate = endDate ?? null;
    if (mtd && adjustedEndDate) {
      adjustedEndDate = new Date(
        Date.UTC(adjustedEndDate.getUTCFullYear(), adjustedEndDate.getUTCMonth(), adjustedEndDate.getUTCDate(), 23, 59, 59, 999)
      );
    }

    const response = await apiService.post(`${this.BASE_PATH}/search`, {
      startDate: startDate.toISOString(),
      endDate: adjustedEndDate?.toISOString(),
      officeId: officeId ? officeId : undefined,
    });
    if (!response.success) return null;

    return response.data as Finance;
  }

  static async getFinanceRequests(
    startDate: Date,
    endDate: Date,
    page = 0,
    size = 10,
    sort = "request.lastName",
    officeId?: string
  ): Promise<ApiPage<FinanceRequest>> {
    const body = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      officeId: officeId ? officeId : undefined,
    };
    const response = await apiService.post(`${this.BASE_PATH}/requests?page=${page}&size=${size}&sort=${sort}`, body);
    if (!response.success) return emptyApiPage<FinanceRequest>();

    return response.data as ApiPage<FinanceRequest>;
  }

  static async getFinanceRevenue(startDate: Date, endDate: Date): Promise<FinanceRevenue | undefined> {
    const body = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
    const response = await apiService.post(`${this.BASE_PATH}/revenue`, body);
    if (!response.success) return undefined;

    return response.data as FinanceRevenue;
  }

  static async getFinanceRevenueBilledTo(startDate: Date, endDate: Date): Promise<FinanceBilledTo[]> {
    const body = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
    const response = await apiService.post(`${this.BASE_PATH}/revenue-billed-to`, body);
    if (!response.success) return [];

    return response.data as FinanceBilledTo[];
  }

  static async getFinanceTopOffices(startDate: Date, endDate: Date): Promise<TopOffice[]> {
    const body = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
    const response = await apiService.post(`${this.BASE_PATH}/top-offices`, body);
    if (!response.success) return [];

    return response.data as TopOffice[];
  }
}
